import { render, staticRenderFns } from "./index.vue?vue&type=template&id=81d67b2a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=81d67b2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d67b2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81d67b2a')) {
      api.createRecord('81d67b2a', component.options)
    } else {
      api.reload('81d67b2a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=81d67b2a&scoped=true&", function () {
      api.rerender('81d67b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preview/index.vue"
export default component.exports